import {TileView} from "@components/interface/TileView";
import {Tile} from "@game/map/tile";
import {Game} from "@game/game";
import {CSSProperties, PointerEventHandler} from "react";

const styles: Record<string, CSSProperties> = {
    content: {
        filter: "drop-shadow(3px 3px 3px rgba(0,0,0,0.3))",
        touchAction: "none"
    },
    disabled: {
        pointerEvents: "none",
        opacity: 0.4
    }
};

interface IPlacedTileController {
    game: Game
    shovelling: boolean
    tile: Tile
}
export function PlacedTileController({game, shovelling, tile}: IPlacedTileController) {
    const handlePointerDown: PointerEventHandler = () => {
        tile.letter && game.userPlayer?.dragPlacedLetter(tile.letter);
    };
    const contentStyle = {
        ...styles.content,
        ...shovelling ? styles.disabled : {}
    };

    return (
        <div data-draggable="placedTileController" onPointerDown={handlePointerDown} style={contentStyle}>
            {tile.letter && <TileView bonus={tile.place?.bonus} dragging={false} letter={tile.letter}/>}
        </div>
    );
}